import { render, staticRenderFns } from "./CardNotAssigned.vue?vue&type=template&id=46a64366"
import script from "./CardNotAssigned.vue?vue&type=script&lang=js"
export * from "./CardNotAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports